import { useState } from "react";
const useDisclosure = (defaultOpenStatus = false)=>{
    const [isOpen, setIsOpen] = useState(defaultOpenStatus);
    const onClose = ()=>{
        setIsOpen(false);
    };
    const onOpen = ()=>{
        setIsOpen(true);
    };
    const onToggle = ()=>{
        setIsOpen(!isOpen);
    };
    return {
        isOpen,
        onClose,
        onOpen,
        onToggle
    };
};
const src_useDisclosure = useDisclosure;
export default src_useDisclosure;
